import { DynamicAttribute, DynamicAttributeDefinition } from "view360Card/models";
import { DynamicAttributeDefinitionDto } from "view360Card/service/dtos/DynamicAttributeDefinitionDto";
import { DynamicAttributeDto } from "view360Card/service/dtos/DynamicAttributeDto";
import orderBy from "lodash/orderBy";
import { constants } from "shared/constants";

export class DynamicAttributeDefinitionFromResponse {
    constructor(private dto: DynamicAttributeDefinitionDto | undefined) {}

    domainModel(): DynamicAttributeDefinition | undefined {
        if (!this.dto) {
            return undefined;
        }

        return {
            id: this.dto.id,
            code: this.dto.code,
            deleted: this.dto.deleted,
            descriptionTranslationCode: this.dto.descriptionTranslationCode,
            description: this.dto.description,
            flexField1: this.dto.flexField1,
            orderIndex: this.dto.orderIndex,
        };
    }
}

export class DynamicAttributeFromResponse {
    constructor(private dto: DynamicAttributeDto) {}

    domainModel(): DynamicAttribute {
        return {
            id: this.dto.id,
            code: this.dto.code,
            definition: new DynamicAttributeDefinitionFromResponse(this.dto.definition).domainModel(),
            tenantCode: this.dto.tenantCode,
            stringValue: this.dto.stringValue,
            longValue: this.dto.longValue,
            decimalValue: this.dto.decimalValue,
            booleanValue: this.dto.booleanValue,
            dateValue: this.dto.dateValue,
            dateTimeValue: this.dto.dateTimeValue,
        };
    }
}

export function sortAndFilterDynamicAttributes(dynamicAttrs: DynamicAttribute[]) {
    const supportedTypes = [
        constants.dynamicAttributeTypes.stringAttrType,
        constants.dynamicAttributeTypes.longAttrType,
        constants.dynamicAttributeTypes.decimalAttrType,
        constants.dynamicAttributeTypes.dateAttrType,
        constants.dynamicAttributeTypes.dateTimeAttrType,
        constants.dynamicAttributeTypes.boolAttrType,
    ];

    const registrationPhoneCode = "REGISTRATION_PHONE";
    const registrationEmailCode = "REGISTRATION_EMAIL";

    const ignoreCodes = [registrationPhoneCode, registrationEmailCode];

    let supportedAttributes = dynamicAttrs.filter(
        (a) => supportedTypes.findIndex((type) => type === a.definition?.flexField1) >= 0
    );
    supportedAttributes = supportedAttributes.filter((a) => ignoreCodes.findIndex((code) => a.code === code) < 0);

    return orderBy(supportedAttributes, [(attr) => attr.definition?.orderIndex]);
}
